export default "__VITE_ASSET__a3c70224__"